/* PRINTMONEY — Production JS v3.0 */
'use strict';

/* ─── LOADER ─────────────────────────────── */
const loader = document.getElementById('pm-loader');
window.addEventListener('load', () => {
  setTimeout(() => { loader && loader.classList.add('done'); }, 2200);
});

/* ─── CURSOR ─────────────────────────────── */
const cur = document.getElementById('pm-cursor');
const ring = document.getElementById('pm-cursor-ring');
if (cur && window.matchMedia('(pointer:fine)').matches) {
  let mx=0,my=0,cx=0,cy=0,rx=0,ry=0;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;});
  const tick=()=>{
    cx+=(mx-cx)*.18; cy+=(my-cy)*.18;
    rx+=(mx-rx)*.09; ry+=(my-ry)*.09;
    cur.style.left=cx+'px'; cur.style.top=cy+'px';
    ring.style.left=rx+'px'; ring.style.top=ry+'px';
    requestAnimationFrame(tick);
  };
  tick();
  document.querySelectorAll('a,button,.pm-pcard,.pm-look,.pm-jcard,.pm-carousel__item').forEach(el=>{
    el.addEventListener('mouseenter',()=>document.body.classList.add('hovering'));
    el.addEventListener('mouseleave',()=>document.body.classList.remove('hovering'));
  });
}

/* ─── HEADER SCROLL ──────────────────────── */
const nav = document.querySelector('.pm-nav');
if(nav){
  const onScroll=()=>nav.classList.toggle('solid',window.scrollY>60);
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
}

/* ─── MOBILE MENU ────────────────────────── */
const burger=document.querySelector('.pm-nav__burger');
const mobileMenu=document.querySelector('.pm-mobile-menu');
const mobileClose=document.querySelector('.pm-mobile-menu__close');
if(burger&&mobileMenu){
  burger.addEventListener('click',()=>mobileMenu.classList.toggle('open'));
  if(mobileClose) mobileClose.addEventListener('click',()=>mobileMenu.classList.remove('open'));
}

/* ─── THREE.JS HERO CANVAS ───────────────── */
function initHeroCanvas(){
  const canvas=document.getElementById('pm-hero-canvas');
  if(!canvas||!window.THREE)return;
  const W=canvas.clientWidth,H=canvas.clientHeight;
  const renderer=new THREE.WebGLRenderer({canvas,alpha:true,antialias:true});
  renderer.setPixelRatio(Math.min(window.devicePixelRatio,2));
  renderer.setSize(W,H);
  const scene=new THREE.Scene();
  const camera=new THREE.PerspectiveCamera(60,W/H,0.1,100);
  camera.position.z=6;
  // Lights
  scene.add(new THREE.AmbientLight(0xffffff,0.5));
  const dl=new THREE.DirectionalLight(0xc9a96e,0.8);
  dl.position.set(4,6,4); scene.add(dl);
  const dl2=new THREE.DirectionalLight(0xe8d5b0,0.4);
  dl2.position.set(-4,-4,2); scene.add(dl2);
  // Geometry
  const geos=[
    [new THREE.IcosahedronGeometry(1.8,1), {x:-3.5,y:2.2,z:-4}, {rx:.003,ry:.005}],
    [new THREE.OctahedronGeometry(1.3,0),  {x:3.8, y:-1.5,z:-3},{rx:.004,ry:-.003}],
    [new THREE.TetrahedronGeometry(1.1,0), {x:0,   y:-.5, z:-5},{rx:.002,ry:.004}],
    [new THREE.IcosahedronGeometry(0.9,0), {x:-1.5,y:3,   z:-3},{rx:-.003,ry:.002}],
  ];
  const meshes=geos.map(([geo,pos,rot])=>{
    const mat=new THREE.MeshPhongMaterial({
      color:0xc9a96e, emissive:0xc9a96e, emissiveIntensity:.08,
      shininess:120, wireframe:false, transparent:true, opacity:.55
    });
    const m=new THREE.Mesh(geo,mat);
    m.position.set(pos.x,pos.y,pos.z);
    m.userData={rx:rot.rx,ry:rot.ry,baseY:pos.y,t:Math.random()*Math.PI*2};
    scene.add(m); return m;
  });
  // Wireframe accent
  const wGeo=new THREE.IcosahedronGeometry(3,1);
  const wMat=new THREE.MeshBasicMaterial({color:0xc9a96e,wireframe:true,transparent:true,opacity:.06});
  const wire=new THREE.Mesh(wGeo,wMat);
  wire.position.set(2,0,-6); scene.add(wire);
  // Mouse parallax
  let mx=0,my=0;
  document.addEventListener('mousemove',e=>{
    mx=(e.clientX/window.innerWidth-.5)*2;
    my=(e.clientY/window.innerHeight-.5)*2;
  });
  let frame=0;
  const animate=()=>{
    frame++;
    meshes.forEach(m=>{
      m.rotation.x+=m.userData.rx;
      m.rotation.y+=m.userData.ry;
      m.userData.t+=.008;
      m.position.y=m.userData.baseY+Math.sin(m.userData.t)*.25;
    });
    wire.rotation.x+=.0008; wire.rotation.y+=.0012;
    camera.position.x+=(mx*.8-camera.position.x)*.04;
    camera.position.y+=(-my*.5-camera.position.y)*.04;
    renderer.render(scene,camera);
    requestAnimationFrame(animate);
  };
  animate();
  window.addEventListener('resize',()=>{
    const W2=canvas.clientWidth,H2=canvas.clientHeight;
    camera.aspect=W2/H2; camera.updateProjectionMatrix();
    renderer.setSize(W2,H2);
  });
}
if(window.THREE) initHeroCanvas();
else {
  const s=document.createElement('script');
  s.src='https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  s.onload=initHeroCanvas; document.head.appendChild(s);
}

/* ─── GSAP HERO ANIMATIONS ───────────────── */
function initHeroGSAP(){
  if(!window.gsap)return;
  gsap.registerPlugin(window.ScrollTrigger);
  const tl=gsap.timeline({delay:.4});
  tl.to('.pm-hero__eyebrow',{opacity:1,y:0,duration:.9,ease:'power3.out',from:{y:20}})
    .fromTo('.pm-hero__eyebrow',{opacity:0,y:20},{opacity:1,y:0,duration:.9,ease:'power3.out'},0)
    .fromTo('.pm-hero__h1',{opacity:0,y:55},{opacity:1,y:0,duration:1.3,ease:'power3.out'},.25)
    .fromTo('.pm-hero__sub',{opacity:0,y:20},{opacity:1,y:0,duration:.9,ease:'power3.out'},.65)
    .fromTo('.pm-hero__btns',{opacity:0,y:20},{opacity:1,y:0,duration:.8,ease:'power3.out'},.9)
    .fromTo('.pm-hero__scroll',{opacity:0},{opacity:1,duration:.8},1.2);
}
if(window.gsap&&window.ScrollTrigger) initHeroGSAP();
else{
  const s1=document.createElement('script');
  s1.src='https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  s1.onload=()=>{
    const s2=document.createElement('script');
    s2.src='https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
    s2.onload=()=>{ gsap.registerPlugin(ScrollTrigger); initHeroGSAP(); initScrollReveal(); };
    document.head.appendChild(s2);
  };
  document.head.appendChild(s1);
}

/* ─── SCROLL REVEAL ──────────────────────── */
function initScrollReveal(){
  const obs=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add('revealed');
        obs.unobserve(e.target);
      }
    });
  },{rootMargin:'0px 0px -80px 0px',threshold:.08});
  document.querySelectorAll('[data-pm-reveal],[data-pm-stagger]').forEach(el=>obs.observe(el));
}
document.addEventListener('DOMContentLoaded',initScrollReveal);

/* ─── GSAP PARALLAX ──────────────────────── */
function initParallax(){
  if(!window.gsap||!window.ScrollTrigger)return;
  document.querySelectorAll('[data-parallax]').forEach(el=>{
    const speed=parseFloat(el.dataset.parallax)||0.25;
    gsap.to(el,{
      yPercent:speed*-30,
      ease:'none',
      scrollTrigger:{trigger:el.parentElement,start:'top bottom',end:'bottom top',scrub:1.5}
    });
  });
  // Stat counters
  document.querySelectorAll('.pm-stat__n[data-count]').forEach(el=>{
    const target=parseInt(el.dataset.count);
    ScrollTrigger.create({trigger:el,start:'top 88%',once:true,onEnter:()=>{
      gsap.fromTo({v:0},{v:target,duration:1.8,ease:'power2.out',
        onUpdate:function(){el.textContent=Math.round(this.targets()[0].v);}});
    }});
  });
}
document.addEventListener('DOMContentLoaded',initParallax);

/* ─── 3D PRODUCT CAROUSEL ───────────────── */
class PMCarousel{
  constructor(wrap){
    this.wrap=wrap;
    this.track=wrap.querySelector('.pm-carousel__track');
    this.items=[...wrap.querySelectorAll('.pm-carousel__item')];
    this.dots=[...wrap.querySelectorAll('.pm-dot')];
    this.prev=wrap.querySelector('[data-prev]');
    this.next=wrap.querySelector('[data-next]');
    this.cur=0;
    this.max=Math.max(0,this.items.length-this.visibleCount());
    this.bind();
    this.go(0);
  }
  visibleCount(){
    const w=this.wrap.clientWidth;
    if(w<640)return 1;
    if(w<1024)return 2;
    return 4;
  }
  go(idx){
    this.cur=Math.max(0,Math.min(idx,this.max));
    const itemW=this.items[0]?.offsetWidth||300;
    const gap=parseFloat(getComputedStyle(this.track).gap)||32;
    const offset=this.cur*(itemW+gap);
    if(window.gsap){
      gsap.to(this.track,{x:-offset,duration:.7,ease:'power3.inOut'});
    } else {
      this.track.style.transform=`translateX(${-offset}px)`;
    }
    // 3D tilt on active
    this.items.forEach((item,i)=>{
      const dist=i-this.cur;
      const rotY=Math.max(-12,Math.min(12,dist*-4));
      const scale=i===this.cur?1:0.96;
      if(window.gsap){
        gsap.to(item,{rotateY:rotY,scale,z:i===this.cur?20:0,
          transformPerspective:1200,duration:.7,ease:'power3.inOut'});
      }
    });
    this.dots.forEach((d,i)=>d.classList.toggle('on',i===this.cur));
  }
  bind(){
    this.prev?.addEventListener('click',()=>this.go(this.cur-1));
    this.next?.addEventListener('click',()=>this.go(this.cur+1));
    this.dots.forEach((d,i)=>d.addEventListener('click',()=>this.go(i)));
    // Touch/drag
    let startX=0,dragging=false;
    this.track.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;dragging=true;},{passive:true});
    this.track.addEventListener('touchend',e=>{
      if(!dragging)return;
      const dx=e.changedTouches[0].clientX-startX;
      if(Math.abs(dx)>50) this.go(dx<0?this.cur+1:this.cur-1);
      dragging=false;
    });
    window.addEventListener('resize',()=>{this.max=Math.max(0,this.items.length-this.visibleCount());this.go(this.cur);});
  }
}

document.querySelectorAll('.pm-carousel-wrap').forEach(w=>new PMCarousel(w));

/* ─── PRODUCT GALLERY ────────────────────── */
const mainImg=document.querySelector('.pm-gallery__main img');
if(mainImg){
  document.querySelectorAll('.pm-gallery__thumb').forEach(thumb=>{
    thumb.addEventListener('click',()=>{
      const src=thumb.querySelector('img')?.src;
      if(!src)return;
      if(window.gsap){
        gsap.to(mainImg,{opacity:0,scale:.97,duration:.2,onComplete:()=>{
          mainImg.src=src;
          gsap.to(mainImg,{opacity:1,scale:1,duration:.35,ease:'power2.out'});
        }});
      } else { mainImg.src=src; }
      document.querySelectorAll('.pm-gallery__thumb').forEach(t=>t.classList.remove('on'));
      thumb.classList.add('on');
    });
  });
}

/* ─── VARIANT SELECTORS ──────────────────── */
document.querySelectorAll('.pm-opts__btns').forEach(group=>{
  group.querySelectorAll('.pm-opt').forEach(btn=>{
    btn.addEventListener('click',()=>{
      group.querySelectorAll('.pm-opt').forEach(b=>b.classList.remove('on'));
      btn.classList.add('on');
    });
  });
});

/* ─── QUANTITY ───────────────────────────── */
const qtyInput=document.querySelector('.pm-qty input');
if(qtyInput){
  document.querySelector('.pm-qty-minus')?.addEventListener('click',()=>{
    qtyInput.value=Math.max(1,parseInt(qtyInput.value)-1);
  });
  document.querySelector('.pm-qty-plus')?.addEventListener('click',()=>{
    qtyInput.value=parseInt(qtyInput.value)+1;
  });
}

/* ─── ADD TO CART ANIMATION ─────────────── */
const atcForm=document.getElementById('pm-atc-form');
if(atcForm){
  atcForm.addEventListener('submit',function(e){
    const btn=this.querySelector('.pm-atc');
    const span=btn?.querySelector('span');
    if(!btn||!span)return;
    e.preventDefault();
    const orig=span.textContent;
    if(window.gsap) gsap.to(btn,{scaleX:.97,duration:.15,yoyo:true,repeat:1});
    span.textContent='ADDING...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:document.getElementById('pm-variant-id')?.value,
        quantity:parseInt(qtyInput?.value||1)})})
      .then(r=>r.json()).then(()=>{
        span.textContent='✓ ADDED TO CART';
        const cnt=document.querySelector('.pm-cart-cnt');
        if(cnt) cnt.textContent=parseInt(cnt.textContent||0)+1;
        setTimeout(()=>span.textContent=orig,1800);
      }).catch(()=>{ span.textContent='TRY AGAIN'; setTimeout(()=>span.textContent=orig,1800); });
  });
}

/* ─── ACCORDION ──────────────────────────── */
document.querySelectorAll('.pm-accord__hd,.pm-faq-q').forEach(hd=>{
  hd.addEventListener('click',()=>{
    const item=hd.closest('.pm-accord__item,.pm-faq-item');
    const isOpen=item.classList.contains('open');
    const siblings=item.parentElement.querySelectorAll('.pm-accord__item,.pm-faq-item');
    siblings.forEach(s=>{
      s.classList.remove('open');
      const b=s.querySelector('.pm-accord__body,.pm-faq-a');
      if(b) b.classList.remove('open');
    });
    if(!isOpen){
      item.classList.add('open');
      const b=item.querySelector('.pm-accord__body,.pm-faq-a');
      if(b) b.classList.add('open');
    }
  });
});

/* ─── NEWSLETTER ─────────────────────────── */
document.querySelectorAll('.pm-nl').forEach(form=>{
  form.addEventListener('submit',e=>{
    e.preventDefault();
    const inp=form.querySelector('input');
    const btn=form.querySelector('button');
    if(!inp?.value)return;
    const orig=btn.textContent;
    btn.textContent='✓ Done';
    inp.value='';
    setTimeout(()=>btn.textContent=orig,2200);
  });
});

/* ─── CONTACT FORM ───────────────────────── */
const contactForm=document.getElementById('pm-contact-form');
if(contactForm){
  contactForm.addEventListener('submit',function(e){
    e.preventDefault();
    const btn=this.querySelector('button[type=submit]');
    const span=btn?.querySelector('span');
    if(span){ span.textContent='SENDING...'; }
    setTimeout(()=>{ if(span){ span.textContent='✓ MESSAGE SENT'; }
      setTimeout(()=>{ if(span) span.textContent='SEND MESSAGE'; this.reset(); },2500); },1200);
  });
}

console.log('%cPRINTMONEY — Luxury Editorial Theme v3.0','font-family:Georgia,serif;font-size:14px;color:#c9a96e;');
